import { gql } from '@apollo/client';

export const GET_CARD_SORT_TEST_SESSION = gql`
  query TestSessions($testSessionId: ID!) {
    testSessions(testSessionId: $testSessionId) {
      id
      testSessionCardSortCategories {
        id
        cardSortCategory {
          id
          name
        }
        testSessionCardSortItems {
          id
          cardSortItem {
            id
            name
            description
            imageUrl
          }
        }
      }
    }
  }
`;
